// Extensions
import VWindowItem from '../VWindow/VWindowItem';
/* @vue/component */
export default VWindowItem.extend({
    name: 'v-tab-item'
});
//# sourceMappingURL=VTabItem.js.map